import React from 'react';
import { useSelector } from 'react-redux';
import { config } from 'utils/config';
import { loadingOverlay } from 'utils/dom';
import { i18n } from 'utils/i18n';
import ANALYTICS from 'constants/analytics';
import Modal from 'components/Modal';
import { ModalFooter } from 'components/Modal/ModalFooter';
import MODAL, { MODAL_BUTTON_TYPES, MODAL_THEMES } from 'constants/modals';
import WINDOW_OBJECT_KEYS from 'constants/windowObjectKeys';
import { isCustomPathReservationSelector, isRestrictedReservationSelector } from 'selectors/customPathCheckInSelectors';
import { isThirdPartyReservationSelector } from 'selectors';

const { ACCEPT, DECLINE } = MODAL_BUTTON_TYPES;

/**
 * CheckInAlreadyActivatedModal
 *
 * @return {JSX} ...
 */
const CheckInAlreadyActivatedModal = () => {
  const isCustomPathReservation = useSelector(isCustomPathReservationSelector);
  const isRestrictedReservation = useSelector(isRestrictedReservationSelector);
  const isThirdPartyReservation = useSelector((state) => isThirdPartyReservationSelector(state));

  const redirectToDetails = (handleClose) => () => {
    handleClose({ analyticsValue: ANALYTICS.VIEW_DETAILS });
    loadingOverlay(true);
    window.location.replace(
      config.getRedirectUrl(
        isCustomPathReservation || isRestrictedReservation || isThirdPartyReservation
          ? WINDOW_OBJECT_KEYS.CUSTOM_PATH_RENTAL_DETAILS
          : WINDOW_OBJECT_KEYS.RENTAL_DETAILS
      )
    );
  };

  return (
    <Modal
      modalKey={MODAL.CHECK_IN_ALREADY_ACTIVATED_MODAL}
      header={i18n('check_in_already_activated_modal_header')}
      theme={MODAL_THEMES.WHITE}
    >
      {({ handleClose }) => (
        <>
          <p
            id={`${MODAL.CHECK_IN_ALREADY_ACTIVATED_MODAL}_desc`}
            className='modal-themed__paragraph modal-themed__paragraph--center-align'
          >
            {i18n('check_in_already_activated_modal_copy')}
          </p>

          <ModalFooter
            buttons={[
              {
                type: DECLINE,
                label: i18n('common_close'),
              },
              {
                type: ACCEPT,
                label: i18n('check_in_already_activated_modal_view_details'),
                handler: redirectToDetails(handleClose),
              },
            ]}
          />
        </>
      )}
    </Modal>
  );
};

export default CheckInAlreadyActivatedModal;
